import React, { useEffect, useState } from "react";
import { CompanyModal } from "./CompanyModal";
import { getCompanies } from "../../api/companies";
import { CompanyDto } from "../../api/companies";
import "./styles/companies-tab.css";

export function CompaniesTab() {
  const [companies, setCompanies] = useState<CompanyDto[]>([]);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [editingCompany, setEditingCompany] = useState<CompanyDto | null>(null);

  useEffect(() => { load(); }, []);

  async function load() {
    setLoading(true);
    const data = await getCompanies();
    setCompanies(data);
    setLoading(false);
  }

  function openNew() { setEditingCompany(null); setModalOpen(true); }
  function openEdit(company: CompanyDto) { setEditingCompany(company); setModalOpen(true); }
  function closeModal() { setModalOpen(false); setEditingCompany(null); load(); }

  return (
    <div className="settings-section-card">
      <div className="settings-header">
        <h2>Компании</h2>
        <button className="btn-primary" onClick={openNew}>Создать компанию</button>
      </div>

      {/* КАРТОЧКИ — только мобильный */}
      <div className="companies-cards">
        {!loading && companies.map((c) => {
          const main = c.contacts?.find((x: any) => x.isMain);
          return (
            <div key={c.id} className="company-card" onClick={() => openEdit(c)}>
              <div className="company-card-row">
                <span className="company-card-name">{c.name}</span>
                {c.roles?.length > 0 && (
                  <span className="role-badge">{c.roles[0]}</span>
                )}
              </div>
              {c.bin && <div className="company-card-meta">БИН: {c.bin}</div>}
              {c.phone && <div className="company-card-meta">{c.phone}</div>}
              {main && <div className="company-card-meta">Контакт: {main.name}</div>}
            </div>
          );
        })}
      </div>

      {/* ТАБЛИЦА — только десктоп */}
      <div className="companies-table-wrap">
        <table className="users-table">
          <thead>
            <tr>
              <th>Название</th>
              <th>БИН</th>
              <th>Телефон</th>
              <th>Email</th>
              <th>Роли</th>
              <th>Основной контакт</th>
              <th>Директор</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {!loading && companies.map((c) => {
              const main = c.contacts?.find((x: any) => x.isMain);
              return (
                <tr key={c.id}>
                  <td>{c.name}</td>
                  <td>{c.bin}</td>
                  <td>{c.phone}</td>
                  <td>{c.email}</td>
                  <td>
                    <div style={{ display: "flex", gap: "6px", flexWrap: "wrap" }}>
                      {c.roles.map((r: string) => (
                        <span key={r} className="role-badge">{r[0].toUpperCase() + r.slice(1)}</span>
                      ))}
                    </div>
                  </td>
                  <td>{main ? main.name : "—"}</td>
                  <td>{c.director}</td>
                  <td>
                    <button className="btn-edit" onClick={() => openEdit(c)}>Открыть</button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {modalOpen && <CompanyModal company={editingCompany} onClose={closeModal} />}
    </div>
  );
}
